'use strict'

export const FETCH_DATA = 'FETCH_DATA'
export const fetchData = makeActionCreator(FETCH_DATA)

export const CURRENCIES_FETCHED = 'CURRENCIES_FETCHED'
export const currenciesFetched = makeActionCreator(
  CURRENCIES_FETCHED,
  'currencies',
  'error'
)

export const RATES_FETCHED = 'RATES_FETCHED'
export const ratesFetched = makeActionCreator(RATES_FETCHED, 'rates', 'error')

export const IP_INFO_FETCHED = 'IP_INFO_FETCHED'
export const ipInfoFetched = makeActionCreator(
  IP_INFO_FETCHED,
  'ipInfo',
  'error'
)

export const LOADING = 'LOADING'
export const loading = makeActionCreator(LOADING, 'value')

// https://github.com/reduxjs/redux/blob/master/docs/recipes/ReducingBoilerplate.md
function makeActionCreator(type, ...argNames) {
  return function(...args) {
    const action = { type }
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index]
    })

    return action
  }
}
